export enum GraphicsLevel {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
}

export interface GraphicsProfile {
  maxResolution: number;
  particles: number;
  trailLength: number;
  trailInterval: number;
  flames: number;
  orbGlow: boolean;
  shadow: boolean;
  patterns: boolean;
  flags: boolean;
  accessories: boolean;
  nameplates: boolean;
  badges: boolean;
  effects: boolean;
}

export const GRAPHICS_PROFILES: Record<GraphicsLevel, GraphicsProfile> = {
  [GraphicsLevel.LOW]: {
    maxResolution: 1,
    particles: 0.4,
    trailLength: 4,
    trailInterval: 4,
    flames: 6,
    orbGlow: false,
    shadow: false,
    patterns: false,
    flags: false,
    accessories: true,
    nameplates: true,
    badges: false,
    effects: false,
  },
  [GraphicsLevel.MEDIUM]: {
    maxResolution: 1.5,
    particles: 0.7,
    trailLength: 8,
    trailInterval: 2,
    flames: 10,
    orbGlow: true,
    shadow: true,
    patterns: true,
    flags: true,
    accessories: true,
    nameplates: true,
    badges: true,
    effects: false,
  },
  [GraphicsLevel.HIGH]: {
    maxResolution: 2,
    particles: 1,
    trailLength: 12,
    trailInterval: 1,
    flames: 16,
    orbGlow: true,
    shadow: true,
    patterns: true,
    flags: true,
    accessories: true,
    nameplates: true,
    badges: true,
    effects: true,
  },
};

export function autoDetectLevel(): GraphicsLevel {
  const nav = (globalThis as {
    navigator?: { deviceMemory?: number; hardwareConcurrency?: number };
  }).navigator;
  if (!nav) return GraphicsLevel.MEDIUM;
  const memory = nav.deviceMemory ?? 4;
  const cores = nav.hardwareConcurrency ?? 4;
  if (memory <= 2 || cores <= 2) return GraphicsLevel.LOW;
  if (memory <= 4 || cores <= 4) return GraphicsLevel.MEDIUM;
  return GraphicsLevel.HIGH;
}

export function selectProfile(level: GraphicsLevel): GraphicsProfile {
  return GRAPHICS_PROFILES[level];
}
